import React from "react";
import {Helmet} from "react-helmet";
// import {injectShopContainer} from '../../react/ShopDataContainer'


export default class Base extends React.Component {
  render () {
    // console.log('hi', shop)
    let name = "JoJo’s Mediterranean Grill – Authentic Lebanese & Mediterranean Cuisine"
    let description = "Authentic Lebanese‑style Mediterranean dishes in West Hollywood and North Hollywood. Freshly made kebabs, hummus, falafel, salads & catering for dine‑in, pickup & delivery."
    return (
      <Helmet>
          <meta charSet="utf-8" />
          <title>{name}</title>
          <meta name="description"
            content={description} />
          <link rel="canonical" href="https://jojosgrill.com" />

          <link rel="manifest" href={`${process.env.PUBLIC_URL}/jojos.json`} />
          <link rel="apple-touch-icon" size s="250x250"
            href={`${process.env.PUBLIC_URL}/jojos.png`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/jojos.png`} />
          <link rel="shortcut icon"
            href={`${process.env.PUBLIC_URL}/jojos.png`}
          />

          {/* Open Graph */}
          <meta property="og:title" content={name} />
          <meta property="og:site_name" content={name} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content="https://afag.imgix.net/jojos-mediterranean-grill/thumbnail.png?w=1500&auto=format" />

          {/* <meta property="og:image" content={} /> */}
          {/* <meta property="og:url" content="http://euro-travel-example.com/index.htm" /> */}
      </Helmet>


    );
  }
};

// export default injectShopContainer(Base)
